module.exports = __webpack_public_path__ + "img/paciente.e720cfc1.png";